import axios from "axios";
const baseUrl = "c-notification";

export default {
  list(pageIndex, unread) {
    return axios.get(baseUrl + `/list`, {
      params: {
        pageIndex,
        isViewUnRead: unread,
      },
    });
  },
  all(pageIndex) {
    return axios.post(baseUrl + `/list?pageIndex=${pageIndex}`);
  },
  getReadList() {
    return axios.get(baseUrl + `/read`);
  },
  postRead() {
    return axios.post(baseUrl + `/read`);
  },
  saveItem(id) {
    return axios.post(baseUrl + `/save`, {
      id: id,
    });
  },
  updateFcm(token) {
    return axios.post(baseUrl + `/update-token-fcm`, {
      token,
    });
  },
};
